import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { InfoBlock } from 'libs/ui';

export const ActionInfo = (props) => {
  const { row, close } = props;
  const { t } = useTranslation();

  const getDateTime = (date, format) => {
    if (date) {
      return moment(date).format(format);
    } else return '';
  };

  if (!row) {
    return null;
  }

  const title = row.action ?? '';
  const fields = [
    { title: t('grid.Дата и время'), value: getDateTime(row.timestamp, 'DD MMM YYYY, HH:mm:ss') },
    { title: t('inputs.Пользователь'), value: row.user?.name },
    { title: t('form.Роль'), value: row.user?.role },
    { title: t('inputs.Описание'), value: row.action },
  ];

  return <InfoBlock title={title} close={close} fields={fields} info={row} />;
};
